angular.module("app").controller("PagesAddPageController", [
    '$scope',
    'pagesService',
    'pageStatuses',
    'pageTypes',
    'preloadedPages',
    'errorHandler',
    'logger',
    'cropperService',
    'userStorage',
    '$stateParams',
    'preloadedPageNames',
    'settingsService',
    function ($scope, pagesService, pageStatuses, pageTypes, preloadedPages, errorHandler, logger, cropperService, userStorage, $stateParams, preloadedPageNames, settingsService) {

        var init;

        $scope.userData = userStorage.getUserData();

        $scope.settings = settingsService.getSettings();
        $scope.pageStatuses = pageStatuses;
        $scope.pageTypes = pageTypes;
        $scope.allPages = angular.copy(preloadedPages.pages);
        $scope.tooltip = {
            pageTitle: ""
        };

        $scope.actualPageNames = preloadedPageNames ? angular.copy(preloadedPageNames.pageNames) : null;

        (init = function () {
            $scope.pageData = {
                title: "",
                name: ($scope.actualPageNames && $scope.actualPageNames[0]) ? $scope.actualPageNames[0].name : null,
                status: $scope.pageStatuses[0],
                type: (!!$stateParams.type) ? $stateParams.type : $scope.pageTypes[0],
                parent: {
                    id: ""
                },
                setToAllLangs: true,
                customFields: {
                    parent: true,
                    children: [

                    ]
                },
                meta_description: "",
                meta_keywords: ""
            };
            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };
            $scope.draggedImage = "";
            $scope.draggedImageDataUrl = "";
            $scope.imageToLoad = undefined;
        })();

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
          if (isEnabled) {
              delete $scope.pageData.lang
          } else {
              $scope.pageData.lang = $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
          }
        };

        $scope.handleChangeOfPageType = function (type) {
            pagesService.getPagesNames({pageType: type}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.actualPageNames = angular.copy(response.pageNames);
                        $scope.pageData.name = $scope.actualPageNames[0].name
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )

        };

        $scope.submitAddPageForm = function () {
            $scope.preview(function (dataUrl) {
                delete $scope.pageData.forceTOChange;
                var requestObj = {
                    page: angular.copy($scope.pageData)
                };

                if (dataUrl != $scope.draggedImageDataUrl) {
                    requestObj.page.image = dataUrl;
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                    delete requestObj.page.image;
                    requestObj.page.media_id = $scope.imageToLoad.id;
                }


                !requestObj.page.global && (delete requestObj.page.global);

                !!$scope.vm.fromDate && (requestObj.page.start_date = $scope.vm.fromDate);
                !!$scope.vm.toDate && (requestObj.page.end_date = $scope.vm.toDate);

                pagesService.create(requestObj).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.saved");
                            init();
                            $scope.add_page_form && $scope.add_page_form.$setPristine && $scope.add_page_form.$setPristine();
                            $scope.$emit("force:reset:editor");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                )
            });
        };

        cropperService.call($scope);

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };
    }
]);